
export enum LogAuthorizationTypes {
  SUCCESSFUL = 1,
  NOT_SUCCESSFUL = 2
}
